import { render, staticRenderFns } from "./EmbedTopNavigation.vue?vue&type=template&id=2af2f7b1"
import script from "./EmbedTopNavigation.vue?vue&type=script&lang=js"
export * from "./EmbedTopNavigation.vue?vue&type=script&lang=js"
import style0 from "./EmbedTopNavigation.vue?vue&type=style&index=0&id=2af2f7b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports